<form [formGroup]="form">
  <div class="flex justify-center">
    <div class="w-full py-12 px-18.5">
      <div class="flex flex-col gap-2">
        <div
          class="w-full h-[200px] rounded-xl bg-gray-100 animate-pulse"></div>
        <div class="w-full h-[45.5px]"></div>
        <input
          pInputText
          [pAutoFocus]="true"
          fluid="true"
          autocomplete="off"
          placeholder="What's your text about?"
          class="!text-5xl !border-none !shadow-none"
          [readonly]="isGenerating() ? 'readonly' : null"
          formControlName="title" />
      </div>

      <p-divider />

      <div class="flex justify-between items-center">
        <div class="flex gap-2">
          <p-button
            label="Customize"
            size="large"
            variant="outlined"
            [rounded]="true"
            icon="pi pi-cog"
            severity="secondary"
            [disabled]="isGenerating()"
            (click)="handleCustomizeClick()" />
          <app-sources-button
            label="Sources"
            [sources]="form.get('sources').value"
            [maxSourceItems]="maxSourceItems"
            [disabled]="isGenerating()"
            (sourcesChange)="handleSourcesChange($event)" />
          <app-sources-button
            label="Style example/s *"
            [sources]="form.get('styleExamples').value"
            [maxSourceItems]="maxStyleExamplesItems"
            [disabled]="isGenerating()"
            (sourcesChange)="handleStyleExamples($event)" />
          @if (featureFlags.projectCreation.startManually) {
            <app-start-manually-button
              [topic]="topic"
              [title]="title"
              [inputParams]="inputParams"
              [disabled]="isGenerating()" />
          }
          <p-button
            label="Generate"
            size="large"
            icon="pi pi-arrow-right"
            iconPos="right"
            [severity]="!form.valid ? 'secondary' : 'primary'"
            [disabled]="!form.valid || isGenerating()"
            [rounded]="true"
            (click)="handleGenerateClick()" />
        </div>
        <div class="flex gap-2">
          <div>
            <app-prompt-language-picker
              [disabled]="isGenerating()"
              [value]="form.get('promptLanguage').value"
              (valueChange)="handlePromptLanguageChange($event)" />
          </div>
        </div>
      </div>
      @if (isGenerating()) {
        <div class="d-flex justify-content-center align-items-center gap-2">
          <div class="spinner-grow text-primary" role="status"></div>
          <div>Generating (might take 3-5 minutes)...</div>
        </div>
      }
    </div>
  </div>
</form>
